const selectors = {
  accordionButton: '[data-js-accordion-button]',
  accordionContent: '[data-js-accordion-content]',
  accordionItem: '[data-js-accordion-item]',
};

const dom = {};

const cacheDom = () => {
  dom.accordionItems = document.querySelectorAll(selectors.accordionItem);
};

const closeAllAccordions = (event) => {
  const currentItem = event.target.closest(selectors.accordionItem);
  dom.accordionItems.forEach((item) => {
    if (item != currentItem) {
      const content = item.querySelector(selectors.accordionContent);
      item.classList.remove('active');
      content.style.maxHeight = null;
    }
  });
};

const openAccordion = (event) => {
  event.stopPropagation();
  const item = event.target.closest(selectors.accordionItem);
  item.classList.add('active');

  const content = item.querySelector(selectors.accordionContent);
  content.animate(
    [{ maxHeight: '0px' }, { maxHeight: `${content.scrollHeight}px` }],
    {
      duration: 400,
      easing: 'cubic-bezier(0.5,0,0.8,0)',
      fill: 'forwards',
    },
  );
  content.firstElementChild.animate([{ opacity: 0 }, { opacity: 1 }], {
    delay: 400,
    duration: 300,
    fill: 'forwards',
  });
  /* if (content.style.maxHeight) {
    content.style.maxHeight = null;
  } else {
    content.style.maxHeight = `${content.scrollHeight}px`;
  } */
};

const closeAccordion = (event) => {
  event.stopPropagation();
  const item = event.target.closest(selectors.accordionItem);
  item.classList.remove('active');

  const content = item.querySelector(selectors.accordionContent);
  content.firstElementChild.animate([{ opacity: 1 }, { opacity: 0 }], {
    duration: 300,
    fill: 'forwards',
  });
  content.animate(
    [{ maxHeight: `${content.scrollHeight}px` }, { maxHeight: '0px' }],
    {
      duration: 400,
      easing: 'cubic-bezier(0.5,0,0.8,0)',
      fill: 'forwards',
    },
  );
};

const initAccordionds = () => {
  if (dom.accordionItems.length > 0) {
    dom.accordionItems.forEach((item) => {
      const button = item.querySelector(selectors.accordionButton);
      const content = item.querySelector(selectors.accordionContent);
      button.addEventListener('click', (event) => {
        // closeAllAccordions(event);
        if (item.classList.contains('active')) {
          closeAccordion(event);
        } else {
          openAccordion(event);
        }
      });
    });
  }
};

const setupAccordions = {
  init() {
    cacheDom();
    initAccordionds();
  },
};

export default setupAccordions;
